import { inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { DevFlagSelectors } from '@core/dev-flags-data';
import { DevFlag } from '@core/dev-flags-types';

export const injectDevFlag = (flag: DevFlag) => {
  let isEnabled = false;
  inject(Store)
    .select(DevFlagSelectors.isEnabled(flag))
    .pipe(take(1))
    .subscribe(data => {
      isEnabled = data;
    });
  return isEnabled;
};
